// extracted by mini-css-extract-plugin
export var masthead = "CampaignMasthead-module--masthead--27bbf";